import { render, staticRenderFns } from "./AppMessageDialog.vue?vue&type=template&id=6bbc3980"
import script from "./AppMessageDialog.vue?vue&type=script&lang=js"
export * from "./AppMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./AppMessageDialog.vue?vue&type=style&index=0&id=6bbc3980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VContainer,VIcon,VRow})
